import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["choices", "frequency", "status", "track", "indicator"]
  static values = { saving: String, saved: String, error: String }

  connect() {
    this.element.dataset.enhanced = ""
    this.resizeObserver = new ResizeObserver(() => this.positionIndicator(false))
    this.resizeObserver.observe(this.trackTarget)
    this.positionIndicator(false)
  }

  disconnect() {
    clearTimeout(this.timeout)
    this.resizeObserver.disconnect()
    delete this.element.dataset.enhanced
  }

  preserveEnhancement(event) {
    if (event.target === this.element && event.detail.attributeName === "data-enhanced") event.preventDefault()
    if (event.target === this.indicatorTarget && event.detail.attributeName === "style") event.preventDefault()
  }

  refreshIndicator({ target }) {
    if (target === this.element) this.positionIndicator(false)
  }

  positionIndicator(animate = true) {
    const choice = this.trackTarget.querySelector("input:checked").parentElement
    const { left, width } = choice.getBoundingClientRect()
    const track = this.trackTarget.getBoundingClientRect()
    this.indicatorTarget.style.transition = animate ? "" : "none"
    this.indicatorTarget.style.transform = `translateX(${left - track.left}px) scaleX(${width / track.width})`
  }

  handleResponse(event) {
    if (!event.detail.fetchResponse.succeeded) event.preventDefault()
  }

  save({ target }) {
    this.frequencyTarget.value = target.value
    this.element.querySelectorAll("input[type=radio]").forEach((input) => {
      input.checked = input.value === target.value
    })
    this.positionIndicator(!target.matches(":focus-visible"))
    this.element.requestSubmit()
  }

  start() {
    clearTimeout(this.timeout)
    this.focusedChoice = this.element.contains(document.activeElement) ? document.activeElement : null
    this.choicesTarget.disabled = true
    this.statusTarget.classList.remove("text-danger-ink")
    this.statusTarget.textContent = this.savingValue
  }

  finish({ detail: { success } }) {
    const options = [...this.frequencyTarget.options]
    if (success) options.forEach((option) => { option.defaultSelected = option.selected })
    else this.frequencyTarget.value = options.find((option) => option.defaultSelected).value

    this.element.querySelectorAll("input[type=radio]").forEach((input) => {
      input.checked = input.value === this.frequencyTarget.value
      input.defaultChecked = input.checked
    })
    this.positionIndicator()

    this.choicesTarget.disabled = false
    if (document.activeElement === document.body) this.focusedChoice?.focus()
    this.statusTarget.classList.toggle("text-danger-ink", !success)
    this.statusTarget.textContent = success ? this.savedValue : this.errorValue
    if (success) this.timeout = setTimeout(() => { this.statusTarget.textContent = "" }, 2500)
  }
}
